import vuex from 'vuex'
import Vue from 'vue'
import axios from 'axios';
import store from "./index.js"
Vue.use(vuex)

const usuario = {
    namespaced: true,
    state: {
        error: "",
        cargado: 0,
        usuarios: [],
        usuarioedit: [],
        olvido: null,
        permisovalidador: false,
    },
    actions: {
        get_usuarios({ commit }, payload) {
            axios.get(`${process.env.VUE_APP_REST}/api/usuario`, payload
            )
                .then(response => {
                    commit('SET_USUARIOS', response.data)
                })
                .catch(e => {
                    commit('SET_ERROR', e.response.data.mensajeRespuesta)
                })
        },
        get_usuarioedit({ commit }, obj) {
            axios.get(`${process.env.VUE_APP_REST}/api/usuario/obtenerusuario/${obj.params.idusuario}` ).then(response => { 
                commit('SET_USUARIOEDIT', response.data)
                })
                .catch(e => {    
                    commit('SET_ERROR', e.response.data.mensajeRespuesta)
                })
        },
        get_permisovalidador({ commit }, obj) {
            axios.get(`${process.env.VUE_APP_REST}/api/usuario/pemisovalidadorsobreindicador/${obj.params.idusuario}/${obj.params.idpunto}` ).then(response => { 
                commit('SET_PERMISOVALIDADOR', response.data)
                })
                .catch(e => {    
                    commit('SET_ERROR', e.response.data.mensajeRespuesta)
                })
        },        
        post_cambiarclaveusuario({ commit }, payload) {
            axios.post(`${process.env.VUE_APP_REST}/api/usuario/cambioclave`, payload
            )
                .then(response => {
                    localStorage.setItem('usuario', JSON.stringify(response.data))
                    commit('SET_ERROR', "")
                    localStorage.setItem('token', response.data["token"])
                    commit('SET_CARGADO', 1)
                    localStorage.removeItem("filtroindicador");
                    localStorage.removeItem("AvanceFiltrado");
                    localStorage.removeItem("IndicadorFiltrado");
                    localStorage.removeItem("HitoFiltrado");
                    localStorage.removeItem("filtrotareas");    
                    localStorage.removeItem("filtrogeneral");    
                    localStorage.removeItem("filtroclasificacion");                                      
                    alert('Su contraseña ha sido modificada de forma exitosa');
                })
                .catch(e => { 
                    console.log(e.response.data)      
                    store.dispatch("mensaje/set_error", e);                            
                        commit('SET_ERROR', e.response.data)                   
                })
        }
        ,
        post_autenticarusuario({ commit }, payload) {
            axios.post(`${process.env.VUE_APP_REST}/api/usuario/autenticar`, payload
            )
                .then(response => {
                    localStorage.setItem('usuario', JSON.stringify(response.data))
                    commit('SET_ERROR', "")
                    localStorage.setItem('token', response.data["token"])
                    commit('SET_CARGADO', 1)
                    localStorage.removeItem("filtroindicador");
                    localStorage.removeItem("AvanceFiltrado");
                    localStorage.removeItem("IndicadorFiltrado");
                    localStorage.removeItem("HitoFiltrado");
                    localStorage.removeItem("filtrotareas");   
                    localStorage.removeItem("filtrogeneral");     
                    localStorage.removeItem("filtroclasificacion");                                                                    
                })
                .catch(e => {                        
                    store.dispatch("mensaje/set_error", e);                            
                        commit('SET_ERROR', e.response.data)                   
                })
        }
        ,
        get_validarolvido({ commit }, payload) {
            axios.get(`${process.env.VUE_APP_REST}/api/usuario/validarolvido/` + payload.enlace 
            )        
            .then(response => {
                commit('SET_OLVIDO', response.data)
            })        
                .catch(e => {                        
                    store.dispatch("mensaje/set_error", e);                            
                        commit('SET_ERROR', e.response.data)                   
                })
        },
        put_cambiarclaveolvido({ commit }, payload) {
            axios.put(`${process.env.VUE_APP_REST}/api/usuario/cambiarclaveolvido` , payload 
            )         
            .then(response => {
                localStorage.setItem('usuario', JSON.stringify(response.data))
                commit('SET_ERROR', "")
                localStorage.setItem('token', response.data["token"])
                commit('SET_CARGADO', 1)
                localStorage.removeItem("filtroindicador");
                localStorage.removeItem("AvanceFiltrado");
                localStorage.removeItem("IndicadorFiltrado");
                localStorage.removeItem("HitoFiltrado");
                localStorage.removeItem("filtrotareas");
                localStorage.removeItem("filtrogeneral");    
                localStorage.removeItem("filtroclasificacion");                                                                        
                alert('Su contraseña ha sido modificada de forma exitosa');
            })                   
                .catch(e => {                        
                    store.dispatch("mensaje/set_error", e);                            
                        commit('SET_ERROR', e.response.data)                   
                })
        },
        put_olvidoclave({ commit }, payload) {
            axios.put(`${process.env.VUE_APP_REST}/api/usuario/olvidoclave/` + payload.login 
            )    .then(response => {
                store.dispatch("mensaje/set_success", response);   
            })                                       
                .catch(e => {                        
                    store.dispatch("mensaje/set_error", e);                            
                        commit('SET_ERROR', e.response.data)                   
                })
        }
        ,
        reload_usuario({ commit }) {
            commit('SET_CARGADO', localStorage.usuario !== undefined ? 1 : 0)
        }
        ,
        clean_usuario({ commit }) {
            localStorage.removeItem('usuario')
            localStorage.removeItem('token')
            localStorage.removeItem('parametros')            
            commit('SET_CARGADO', 0)
        },
        clean_error({ commit }) {
            commit('SET_ERROR', "")
        }
    },
    mutations: {
        SET_OLVIDO(state, valor) {
            state.olvido = valor
        },
        SET_ERROR(state, mensaje) {            
            state.error = mensaje
        }
        ,
        SET_CARGADO(state, valor) {
            state.cargado = valor
        },
        SET_USUARIOS(state, valor) {
            state.usuarios = valor
        },
        SET_USUARIOEDIT(state, datos) {
            state.usuarioedit = datos
        },
        SET_PERMISOVALIDADOR(state, valor) {
            state.permisovalidador = valor
        }
    },
    getters: {
        gcargado(state) {
            return state.cargado !== 0
        },
        gcargadolocal() {
            return localStorage.usuario !== undefined
        }
        ,
        gerror(state) {
            return state.error
        }
        ,
        gexisteerror(state) {
            if (state.error !== "") { return true }
            else { return false }
        },
        gusuario() {
            if (localStorage.usuario !== undefined)
                return JSON.parse(unescape(localStorage.usuario));
            return undefined;
        },
        gusuarios(state) {
            return state.usuarios;
        },
        gusuarioedit(state) {
            return state.usuarioedit;
        },
        golvido(state)
        {
            return state.olvido;
        },
        gpermisovalidador(state)
        {
            return state.permisovalidador;
        }
    }
}

export default usuario;
